/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FootfallConfiguration
 */
export interface FootfallConfiguration {
    /**
     * Boundaries of shop entrances/exits for Vividi Footfall module. If no boundaries are specified, all boundaries defined in the locality are used.
     * @type {Array<number>}
     * @memberof FootfallConfiguration
     */
    footfallBoundaries: Array<number>;
}

export function FootfallConfigurationFromJSON(json: any): FootfallConfiguration {
    return FootfallConfigurationFromJSONTyped(json, false);
}

export function FootfallConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FootfallConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'footfallBoundaries': json['footfall_boundaries'],
    };
}

export function FootfallConfigurationToJSON(value?: FootfallConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'footfall_boundaries': value.footfallBoundaries,
    };
}

